import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const WorkHistoryCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const {
    inc_workhistory,
    inc_workhistory_keyonly,
    inc_workhistory_jobtitle,
    inc_workhistory_timeframe,
    inc_workhistory_duration,
    inc_workhistory_industry,
    inc_workhistory_persondescription,
    inc_workhistory_personskills,
    inc_workhistory_personroles,
  } = state

  return (
    <CVCard
      title={t('CVTemplates.WorkHistory')}
      description={t('CVTemplates.WorkHistoryAndExperience')}
      isEnabled={inc_workhistory}
      toggleName='inc_workhistory'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox
          name='inc_workhistory_keyonly'
          label={t('CVTemplates.KeyEmploymentsOnly')}
          value={inc_workhistory_keyonly}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_workhistory_jobtitle'
          label={t('CVTemplates.ShowJobTitle')}
          value={inc_workhistory_jobtitle}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_workhistory_timeframe'
          label={t('CVTemplates.ShowTimeframe')}
          value={inc_workhistory_timeframe}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_workhistory_duration'
          label={t('CVTemplates.ShowDuration')}
          value={inc_workhistory_duration}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_workhistory_industry'
          label={t('CVTemplates.ShowIndustry')}
          value={inc_workhistory_industry}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_workhistory_persondescription'
          label={t('CVTemplates.ShowPersonDescription')}
          value={inc_workhistory_persondescription}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_workhistory_personskills'
          label={t('CVTemplates.ShowPersonSkills')}
          value={inc_workhistory_personskills}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_workhistory_personroles'
          label={t('CVTemplates.ShowPersonRoles')}
          value={inc_workhistory_personroles}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
